import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeMapDoc, typeMapFamilia, typeMapGeriatrico, typeMapSelection } from '@monorepo/models';

class MapServices {
    private Base = pointer.map;
    //
    Get = async () => {
        const data = await api.SendRequest<{ mapDoc: typeMapDoc; }>(this.Base, 'GET');
        return data;
    }
    //
    AddFamilia = async (familia: typeMapFamilia) => {
        const data = await api.SendRequest(`${this.Base}/familia`, 'POST', { familia });
        return data;
    }
    DeleteFamilia = async (familiaId: number) => {
        const data = await api.SendRequest(`${this.Base}/familia`, 'DELETE', { familiaId });
        return data;
    }
    UpdateFamilia = async (familia: typeMapFamilia) => {
        const data = await api.SendRequest(`${this.Base}/familia`, 'PUT', { familia });
        return data;
    }
    //
    AddGeriatrico = async (geriatrico: typeMapGeriatrico) => {
        const data = await api.SendRequest(`${this.Base}/geriatrico`, 'POST', { geriatrico });
        return data;
    }
    DeleteGeriatrico = async (geriatricoId: number) => {
        const data = await api.SendRequest(`${this.Base}/geriatrico`, 'DELETE', { geriatricoId });
        return data;
    }
    UpdateGeriatrico = async (geriatrico: typeMapGeriatrico) => {
        const data = await api.SendRequest(`${this.Base}/geriatrico`, 'PUT', { geriatrico });
        return data;
    }
    //
    AddSelection = async (selection: typeMapSelection) => {
        const data = await api.SendRequest(`${this.Base}/selection`, 'POST', { selection });
        return data;
    }
    DeleteSelection = async (selectionName: string) => {
        const data = await api.SendRequest(`${this.Base}/selection`, 'DELETE', { selectionName });
        return data;
    }
    UpdateSelection = async (selection: typeMapSelection) => {
        const data = await api.SendRequest(`${this.Base}/selection`, 'PUT', { selection });
        return data;
    }
}

export const mapServices = new MapServices();
